<style>
  .yyds{
    
  }
</style>
<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 1.tabbar-container-start -->
    <tabbar :tabbarIndex="5"></tabbar>
    <!-- <img width="100%" src="../../images/head.png"> -->
    <img
      width="100%"
      :src="web_top_imgurl"
      @click="link(web_top_linkurl)"
      alt=""
    />
    <marquee behavior="scroll" class="tishi">{{ web_rolling_notice }}</marquee>
    <!-- 1.tabbar-container-end -->

    <!-- 2.main-container-start -->
    <div class="main">
      <div class="yyds">
        <div class="top">
          <span class="text">订单详情</span>
          <div class="sj"></div>
        </div>
        <div @click="goBack" class="goBack c-animation hands">返回</div>
      </div>
      <div class="bottom borderShadow" v-for="(items,index) in currentPageInfo" :key="index">
        <div class="info">
          <!-- <div class="top">订单信息</div> -->
          <div class="bottom">
            <div class="line flexStyle2">
              <!-- <div class="item"> -->
                  <table border="1" cellspacing="0">
                  <tr>
                    <td>订单编号</td>
                    <td colspan="3">{{ items.order_num }}</td>
                  </tr>
                  <tr>
                    <td>订单创建时间</td>
                    <td colspan="3">
                      <div class="right">
                        {{
                          items.create_time || "1970-01-01 12:00:00"
                        }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>商品名称</td>
                    <td>快递方式</td>
                    <td>配送单号</td>
                    <td>物流信息</td>
                  </tr>
                  <tr v-if="items.son_order==''">
                    <td style="width: 400px; text-align: center">
                      <div class="right">
                            {{ items.goods_info }}
                      </div>  
                    </td>
                 
                    <td style="min-width:200px">
                      <div
                        class="item flexStyle2"
                        style="justify-content: center"
                      >
                        <div class="right">
                        
                            {{ items.delivery_name || "暂无" }}
                        </div>  
                      </div>
                    </td>
                    <td>
                      <div class="right">
                        
                          {{ items.delivery_num || "暂无" }}
                        
                      </div>
                    </td>
                    <td>
                      <button class="wuliu" @click="watchTrackInfo">
                        物流轨迹
                      </button>
                      <!-- <div class="line line2 flexStyle2">
                        <div
                          v-if="currentPageInfo.order_track"
                          class="item item2 item3 flexStyle2"
                        >
                          <div v-if="currentPageInfo.order_track.length > 0">-->
                      <!-- <div class="tip">物流信息</div> -->
                      <!-- <div
                              v-for="(item_tarck, index) of JSON.parse(
                                currentPageInfo.order_track
                              )"
                              :key="index"
                            >
                              <hr v-if="index > 0" />
                              <span>{{ item_tarck.time || "暂无时间" }}</span
                              >&nbsp;&nbsp;&nbsp;&nbsp;{{
                                item_tarck.context || "暂无内容"
                              }}
                            </div>
                          </div>
                        </div>
                      </div>  -->
                    </td>
                  </tr>
                  <tr v-for="(item,index) of items.son_order" :key="index">
                    <td style="width: 400px; text-align: center">
                      <div class="right">
                            {{ item.goods_info }}
                      </div>  
                    </td>
                 
                    <td style="min-width:200px">
                      <div
                        class="item flexStyle2"
                        style="justify-content: center"
                      >
                        <div class="right">
                        
                            {{ item.delivery_name || "暂无" }}
                        </div>  
                      </div>
                    </td>
                    <td>
                      <div class="right">
                        
                          {{ item.delivery_num || "暂无" }}
                        
                      </div>
                    </td>
                    <td>
                      <button class="wuliu" @click="watchTrackInfo">
                        物流轨迹
                      </button>
                      <!-- <div class="line line2 flexStyle2">
                        <div
                          v-if="currentPageInfo.order_track"
                          class="item item2 item3 flexStyle2"
                        >
                          <div v-if="currentPageInfo.order_track.length > 0">-->
                      <!-- <div class="tip">物流信息</div> -->
                      <!-- <div
                              v-for="(item_tarck, index) of JSON.parse(
                                currentPageInfo.order_track
                              )"
                              :key="index"
                            >
                              <hr v-if="index > 0" />
                              <span>{{ item_tarck.time || "暂无时间" }}</span
                              >&nbsp;&nbsp;&nbsp;&nbsp;{{
                                item_tarck.context || "暂无内容"
                              }}
                            </div>
                          </div>
                        </div>
                      </div>  -->
                    </td>
                  </tr>
                </table>
                 
               
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 2.main-container-end -->

    <!-- 100.footer-container-start -->
    <c-footer></c-footer>
    <!-- 100.footer-container-end -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";

export default {
  data() {
    // 1.data
    return {
      web_rolling_notice: "", //滚动公告
      web_top_imgurl: "", // pc顶部图片链接
      web_top_linkurl: "", // pc顶部跳转链接
      currentPageInfo: {}, // 1.1.currentPageInfo
      trackInfo: "", // 1.2.物流信息
      sonOrder: [], // 1.3.子订单信息
    };
  },

  components: {
    // 2.components
    tabbar, // 2.1.tabbar
    cFooter: footer, // 2.2.footer
  },

  methods: {
    // 3.methods
    copyText(value) {
      // 3.1.copyText
      let inputObject = document.createElement("input");
      document.body.appendChild(inputObject);
      inputObject.style.visibility = "none";
      inputObject.value = value;
      inputObject.select();
      document.execCommand("copy");

      this.$message({
        showClose: true,
        message: "已复制到剪切板",
        type: "success",
      });
      inputObject.style.display = "none";
    },

    watchTrackInfo(trackInfo) {
      // 3.2.查看物流信息
      if (trackInfo) {
        this.$router.push(
          "/trackInfo?obj=" + encodeURIComponent(JSON.stringify(trackInfo))
        );
      } else {
        this.$notify({
          title: "提示",
          message: "暂无物流信息",
        });
      }
    },

    goBack() {
      // 3.3.返回
      this.$router.go(-1);
    },
    link(url) {
      if (url != "") {
        url =
          url.toLowerCase().indexOf("http:") > -1 ||
          url.toLowerCase().indexOf("https:") > -1
            ? url
            : "http://" + url;
        window.location = url;
      }
    },
  },

  mounted() {
    this.web_rolling_notice = localStorage.web_rolling_notice || ""; //滚动公告
    this.web_top_imgurl = localStorage.web_top_imgurl || "";
    this.web_top_linkurl = localStorage.web_top_linkurl || "";
    this.currentPageInfo = JSON.parse(
      decodeURIComponent(this.$route.query.obj)
    );
    console.log("this.currentPageInfo");
    console.log(this.currentPageInfo);
    this.currentPageInfo.forEach((item,index)=>{
      this.sonOrder[index]=item.son_order
    })
    // this.sonOrder = this.currentPageInfo.son_order;
    if (this.currentPageInfo.order_track) {
      this.trackInfo = JSON.parse(this.currentPageInfo.order_track);
    }
  },
};
</script>

<style scoped lang="scss">
@import "./orderDetail.scss";
table {
  width: 80%;
  text-align: center;
  font-size: 18px;
}
table tr {
  height: 60px;
}
.wuliu {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  background-color: #dd3242;
  border: none;
}
</style>